import { AppRoutes } from '../router/AppRoutes';

export interface YouTubeTutorial {
  videoId: string;
  title: string;
}

export const youtubeTutorialsConfig: Record<string, YouTubeTutorial> = {
  [AppRoutes.Calendar]: { videoId: '_qP-1OGTRKE', title: 'Get Organized with Growegy' },
  [AppRoutes.BusinessPlan]: {
    videoId: '2xm8aYJtoCI',
    title: 'Business Plans with AI Assistants',
  },
  [AppRoutes.Funding]: {
    videoId: 'nW5dkH8K22c',
    title: 'Growegy Business Funding Match Overview',
  },
  [AppRoutes.Marketplace]: { videoId: 'd-QYY0nMU70', title: 'Growegy Marketplace' },
  [AppRoutes.GrowegyAI]: { videoId: 'kaL9T4Fe9VU', title: 'Growegy AI Guide' },
  [AppRoutes.Billing]: { videoId: 'oz3xpWfv8Bo', title: 'Growegy Billing Portal' },
  [AppRoutes.Settings]: { videoId: 'oz3xpWfv8Bo', title: 'Growegy Billing Portal' },
  [AppRoutes.Home]: { videoId: 'kaL9T4Fe9VU', title: 'Growegy AI Guide' },
};
